import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { SelectorOptions } from '../selector-options';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatChipGrid } from '@angular/material/chips';
import { CreateElement } from '../create-element.model';

@Component({
    selector: 'app-selector-chips',
    templateUrl: './selector-chips.component.html',
    styleUrls: ['./selector-chips.component.scss'],
    standalone: false
})
export class SelectorChipsComponent implements OnInit {
  optionsFormGroup: FormGroup;
  visible = true;
  selectable = true;
  removable = true;
  @Input() hasEdit = false;
  @Input() hasUpdate = false;
  addOnBlur = true;
  isOverlayClosed = true;
  @ViewChild('selectorChips', { static: false }) selector: ElementRef;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  @Input() optionsList: any[] = [];
  @Input() selectorOptions: SelectorOptions;
  @Input() title: string;
  @Input() isValid: boolean;
  @Input() textField = 'text';
  @Input() idField = 'id';
  @Input() createElement: CreateElement;
  @Input() readonly: boolean;
  @Input() _module: string;
  @Output() changedOptions: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() editChip: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('chipGrid') chipGrid: MatChipGrid;

  constructor(
    private readonly formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.getFormChips();
  }

  getFormChips() {
    this.optionsFormGroup = this.formBuilder.group({
      optionsControls: [this.optionsList]
    });
  }

  onAddOption(event: any) {
    this.getFormChips();
    Object.entries(event).map(([eventKey, value]) => {
      if (eventKey === this.idField) {
        if (this.optionsList.length === 0) {
          this.addAndEmitOptions(event);
        } else {
          const found = this.optionsList.find(option => option[this.idField] === event[this.idField]);
          if (found) {
            return;
          }
          this.addAndEmitOptions(event);
        }
      } else {
        if (this.optionsList.length === 0) {
          this.addAndEmitOptions(event);
        } else {
          const found = this.optionsList.find(option => option[this.textField] === event[this.textField]);
          if (found) {
            return;
          }
          this.addAndEmitOptions(event);
        }
      }
    });
  }

  private addAndEmitOptions(event: any) {
    this.optionsList.push(event);
    this.changedOptions.emit(this.optionsList);
    this.chipGrid.errorState = false;
    this.optionsFormGroup.controls.optionsControls.setValue(this.optionsList);
  }

  removeOption(event: any) {
    const index = this.optionsList.indexOf(event);
    if (index >= 0) {
      this.optionsList.splice(index, 1);
    }
    if (this.optionsList.length === 0) {
      this.chipGrid.errorState = true;
      this.optionsFormGroup.controls.optionsControls.setValue('');
    }
    this.changedOptions.emit(this.optionsList);
  }

  onEditChip(option) {
    this.editChip.emit(option.id);
  }

  getOptionText(option: any): string {
    let text: string;
    Object.entries<string>(option).map(([key, value]) => {
      if (key === this.textField) {
        text = value;
      }
    });
    return text;
  }

}
